<template lang='pug'>
#modal-selecionar-cars-sobrepostos
        el-dialog(
            :visible.sync='show',
            :title="$t('mensagens.territorio.carSobreposto.titulo')",
            :close-on-click-modal='false',
            :close-on-press-escape='false',
            :destroy-on-close='true',
            :show-close='false',
            width='85%'
        )
            main
                .mensagem
                    p
                        | {{ $t('mensagens.territorio.carSobreposto.foiEncontradaSobreposicao') }}
                        br
                        | {{ $t('mensagens.territorio.carSobreposto.incorporarGeometriaDoCar') }}

                .mapa
                    mapa(
                        :mapLayersConfigs='mapLayersConfigs',
                        :mapConfig='mapConfig',
                        height='100%',
                        idMapa='mapaListCars',
                        ref='mapa'
                    )

                .cars-sobrepostos
                    .lista
                        .car-sobreposto(
                            v-for='car in cars',
                            @mouseover='highlightCAR = car',
                            @mouseleave='highlightCAR = ``'
                        )
                            .checkbox
                                el-checkbox(
                                    :key='car',
                                    @change='value => changeCheckbox(value, car)'
                                ) {{ car }}
                            .acoes
                                el-tooltip(:content="$t('mensagens.territorio.carSobreposto.ignorar')", placement='left')
                                    i.el-icon-remove-outline.mr-2(
                                        @click='ignorarCAR(car)'
                                    )
                                el-tooltip(:content="$t('mensagens.territorio.carSobreposto.vincular')", placement='right')
                                    i.el-icon-circle-plus-outline(
                                        @click='vincularCAR(car)'
                                    )

                    footer.mt-3(
                        v-if='carsSelecionados.length === 0 && cars.length > 0'
                    )
                        BaseButton(
                            type='primary',
                            plain,
                            size='mini',
                            @click='ignorarTodos'
                        )
                            | {{ $t('mensagens.territorio.carSobreposto.ignorarTodos') }}
                        BaseButton(
                            type='primary',
                            size='mini',
                            @click='vincularTodos'
                        )
                            | {{ $t('mensagens.territorio.carSobreposto.vincularTodos') }}

                    footer.mt-3(v-else-if='cars.length > 0')
                        BaseButton(
                            type='primary',
                            plain,
                            size='mini',
                            @click='ignorarSelecionados'
                        )
                            | {{ $t('mensagens.territorio.carSobreposto.ignorar') }} {{ carsSelecionados.length === 1 ? $t('mensagens.territorio.carSobreposto.selecionado') : $t('mensagens.territorio.carSobreposto.selecionados') }}
                        BaseButton(
                            type='primary',
                            size='mini',
                            @click='vincularSelecionados'
                        )
                            | {{ $t('mensagens.territorio.carSobreposto.vincular') }} {{ carsSelecionados.length === 1 ? $t('mensagens.territorio.carSobreposto.selecionado') : $t('mensagens.territorio.carSobreposto.selecionados') }}

                    footer.mt-3(v-else-if='cars.length === 0')
                        BaseButton(size='mini', v-if='usuarioLogado.carTerritorioObrigatorio', @click='ignorarTodos')
                            | {{ $t('mensagens.territorio.carSobreposto.ignorarTodos') }}

                        BaseButton(v-else size='mini', disabled)
                            | {{ $t('mensagens.territorio.carSobreposto.ignorarTodos') }}

                        BaseButton(size='mini', disabled)
                            | {{ $t('mensagens.territorio.carSobreposto.vincularTodos') }}

                .cars-vinculados(v-show='carsVinculados.length > 0')
                    h2.mt-3.mb-2 {{ $t('mensagens.territorio.carSobreposto.carsVinculados') }}
                    .lista-cars-vinculados
                        span(v-for='carVinculado in carsVinculados') {{ carVinculado }}

            footer.my-3(slot='footer')
                BaseButton(
                    @click='mostrarModalConfirmacaoVoltar = true',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.voltar') }}

                BaseButton(
                    :disabled='validarBotaoSalvar()',
                    type='primary',
                    size='mini'
                    @click='salvar'
                )
                    | {{ $t('mensagens.comuns.salvar') }}

        el-dialog.voltar(
            :visible.sync='mostrarModalConfirmacaoVoltar',
            title='Atenção, ao voltar para a tela anterior, as vinculações realizadas não serão salvas. Deseja prosseguir?',
            :destroy-on-close='true',
            :show-close='false',
            width='30%',
            append-to-body
        )
            footer.voltar__footer
                BaseButton(
                    @click='mostrarModalConfirmacaoVoltar = false',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.cancelar') }}
                BaseButton(
                    type='primary',
                    @click='fecharModalDeSobreposicao',
                    size='mini'
                )
                    | {{ $t('mensagens.comuns.prosseguir') }}

        .cars-vinculados
</template>

<script>
import Mapa from '@/components/MapaLeaflet';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import UtilsService from '@/services/UtilsService';
import { mapGetters } from 'vuex';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalSelecionarCarsSobrepostos',

    components: {
        Mapa,
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },

        cars: {
            type: Array,
            required: false
        },

        geometriaTerritorio: {
            type: Object,
            required: false
        },

        firstCars: {
            type: Array,
            required: false
        },

        carEspecificado: {
            type: Boolean,
            default: false
        }
    },

    emits: ['voltar', 'salvar', 'ignorar-todos'],

    data() {
        return {
            mapLayersConfigs: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                }
            },
            highlightCAR: '',
            highlightCARAtivo: '',
            geometriasCAR: {},
            carsVinculados: [],
            mostrarModalConfirmacaoVoltar: false,
            carsSelecionados: []
        };
    },

    created() {
        this.configureLayersMapa();
    },

    watch: {
        highlightCAR: function() {
            if (this.highlightCAR === '') {
                this.mapLayersConfigs = this.mapLayersConfigs.filter(
                    ({ name }) => name !== `highlight_${this.highlightCARAtivo}`
                );
            } else {
                this.highlightCARAtivo = this.highlightCAR;

                this.mapLayersConfigs.push({
                    style: getEstiloGeometria('carHighlight'),
                    name: `highlight_${this.highlightCAR}`,
                    geoJson: this.geometriasCAR[this.highlightCAR]
                });
            }
        },

        geometriaTerritorio: function() {
            this.configureLayersMapa();
        }
    },
    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        configureLayersMapa() {
            this.mapLayersConfigs = [];
            this.carsVinculados = this.firstCars;
            UtilsService.getDadosCAR({
                codigosCar: Array.from(this.cars).toString()
            }).then(({ data }) => {
                data.resultados.forEach(({ geometry, properties }) => {
                    this.geometriasCAR[properties.codigo] = geometry;
                    this.mapLayersConfigs.push({
                        style: getEstiloGeometria('car'),
                        name: properties.codigo,
                        geoJson: geometry
                    });
                });

                this.mapLayersConfigs.push({
                    style: getEstiloGeometria('area'),
                    name: 'Geometria territorio',
                    geoJson: this.geometriaTerritorio
                });
            });
        },

        limparMapa() {
            this.mapLayersConfigs = [];

            this.mapLayersConfigs.push({
                style: getEstiloGeometria('area'),
                name: 'Geometria territorio',
                geoJson: this.geometriaTerritorio
            });
        },

        ignorarCAR(car) {
            this.cars.splice(this.cars.indexOf(car), 1);
            this.mapLayersConfigs = this.mapLayersConfigs.filter(
                ({ name }) => name !== car
            );
        },

        ignorarTodos() {
            this.limparMapa();
            this.cars = [];
            if (this.carsVinculados.length === 0) {
                this.$emit('ignorar-todos', this.geometriaTerritorio);
            }
        },

        validarBotaoSalvar() {
            if (this.usuarioLogado.carTerritorioObrigatorio) {
                return this.carsVinculados.length === 0;
            }

            if (this.cars.length > 0 && !this.carEspecificado) {
                return true;
            }

            return false;
        },

        vincularCAR(car) {
            this.cars.splice(this.cars.indexOf(car), 1);
            this.carsVinculados.push(car);

            this.mapLayersConfigs = this.mapLayersConfigs.filter(
                ({ name }) => name !== car
            );
        },

        vincularTodos() {
            this.limparMapa();

            this.carsVinculados = [...this.carsVinculados, ...this.cars];
            this.cars = [];
        },

        fecharModalDeSobreposicao() {
            this.mostrarModalConfirmacaoVoltar = false;
            this.$emit('voltar');
        },

        salvar() {
            this.$emit('salvar', this.carsVinculados);
        },

        changeCheckbox(carSelecionado, car) {
            if (carSelecionado) {
                this.carsSelecionados.push(car);
            } else {
                this.carsSelecionados.splice(
                    this.carsSelecionados.indexOf(car),
                    1
                );
            }
        },

        vincularSelecionados() {
            this.carsSelecionados.forEach(car => this.vincularCAR(car));
            this.carsSelecionados = [];
        },

        ignorarSelecionados() {
            this.carsSelecionados.forEach(car => this.ignorarCAR(car));
            this.carsSelecionados = [];
        }
    }
};
</script>

<style lang='scss' scoped>
#modal-selecionar-cars-sobrepostos {
    main {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
            'mensagem mensagem'
            'mapa cars-sobrepostos'
            'cars-vinculados cars-vinculados';
    }

    .mensagem {
        grid-area: mensagem;
    }

    .mapa {
        grid-area: mapa;

        height: 400px;
        overflow: hidden;
        border-radius: 4px 0 0 4px;
    }

    .list-select-cars {
        grid-area: list-select-cars;

        .lista-cars {
            @include scroll-bar();
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            max-height: 200px;
            overflow: auto;
            border-bottom: 1px solid var(--gray);

            span {
                font-size: 12px;
                width: 350px;
            }
        }
    }

    .cars-sobrepostos {
        grid-area: cars-sobrepostos;

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 400px;
        overflow: auto;

        border-radius: 0 4px 4px 0;
        border: 1px solid var(--gray);
        padding: 16px;

        .lista {
            @include scroll-bar();
            overflow: auto;
            border-bottom: 1px solid grey;
            min-height: 323px;

            .car-sobreposto {
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 8px;
                border-radius: 2px;
                margin-bottom: 4px;

                .acoes {
                    i {
                        font-size: 15px;
                    }
                }
            }

            .car-sobreposto:hover {
                background-color: var(--default-background-color);
            }
        }
    }

    .cars-vinculados {
        grid-area: cars-vinculados;

        .lista-cars-vinculados {
            @include scroll-bar();
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
            max-height: 200px;
            overflow: auto;
            border-bottom: 1px solid var(--gray);

            span {
                font-size: 12px;
                width: 350px;
            }
        }
    }

    footer {
        display: flex;
        justify-content: space-between;
    }
}

.el-checkbox {
    margin-bottom: 0 !important;
}

.voltar__footer {
    display: flex !important;
    justify-content: space-between !important;
}
</style>
